import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GestioneUtentiService } from 'src/app/core/services/gestione-utenti/gestione-utenti.service';

@Component({
  selector: 'app-email-box-dialog',
  templateUrl: './email-box-dialog.component.html',
  styleUrls: ['./email-box-dialog.component.scss']
})
export class EmailBoxDialogComponent implements OnInit {

  form: FormGroup;

  userData: {
    username: string;
    email: string;
  };

  constructor(
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    private service: GestioneUtentiService,
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) private dialogData: any
  ) { }

  ngOnInit(): void {
    this.userData = this.dialogData;

    this.form = this.formBuilder.group({
      subject: ['', Validators.required],
      content: ['', Validators.required]
    });
  }

  public async sendEmail() {
    this.snackBar.open('Invio mail in corso...', '', {
      duration: 2000,
      verticalPosition: 'bottom',
      panelClass: ['warning-snackbar'],
    });

    const emailModel = this.form.value;

    const result = await this.service.sendEmail({
      address: this.userData.email,
      subject: emailModel.subject,
      text: emailModel.content
    }).catch(
      error => {
        console.log('ERROR in GESTIONE UTENTI - SEND EMAIL', error);
        this.snackBar.open('Invio mail non riuscito', '', {
          duration: 4000,
          verticalPosition: 'bottom',
          panelClass: ['failure-snackbar'],
        });
      }
    );

    if (!result) { return; }

    this.dialogRef.close(true);
  }

}
